import React from 'react';

const TopBar = () => {
  return (
    <div className="bg-slate-900 text-white py-2 text-sm hidden md:block">
      <div className="container mx-auto px-6 md:px-12 flex justify-between items-center">
        <div className="flex flex-col md:flex-row items-center space-y-1 md:space-y-0 md:space-x-6">
          <span className="flex items-center gap-2">
            <i className="fas fa-map-marker-alt text-primary"></i>
            103B, Temple Road, Malapalla, Kottawa
          </span>
          <a href="mailto:smilecarevipcenter@gmail.com" className="flex items-center gap-2 hover:text-primary transition-colors">
            <i className="fas fa-envelope text-primary"></i>
            smilecarevipcenter@gmail.com
          </a>
        </div>
        <div className="flex items-center gap-4">
          <a className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors duration-300" href="https://www.facebook.com/share/16xZhHVTJ3/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook-f text-xs"></i>
          </a>
          <a className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors duration-300" href="#">
            <i className="fab fa-youtube text-xs"></i>
          </a>
          <a className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors duration-300" href="https://www.instagram.com/smilecarevipcenter" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram text-xs"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
